/**
* file : TournamentRelated/Common/PrizeWinner.jsx
* 설명 : 입상자
*/

import icon3 from "assets/images/icon3.png"

import { Fnc } from "common/globals";
import { Link } from 'react-router-dom';
import { useState , useEffect } from "react";
import { Search } from "components/Common/ApiCall";

export default function PrizeWinner( props ) {
  // 데이터
  const [datas, setDatas] = useState(); 
  // 리스트 갯수
  const [listCount, setListCount] = useState(10)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 10
    setListCount(count);
  }
  // 조회
  useEffect(() => {
    Search('/tournament-prize-winner', setDatas, props.setDataLoading, {tournament_idx: props.tournament_idx});
  }, []);

  return (
    <>
      <div className="prize-winner">
        <img src={icon3} alt="icon3" />
        <span>입상자</span>
      </div>
      <div className="table-container">
        <table className="table_style1">
          <thead>
            <tr>
              <th>랭킹</th>
              <th>회원 ID</th>
              <th>베팅금액</th>
              <th>당첨금액</th>
              <th>상금</th>
            </tr>
          </thead>
          <tbody>
            {
              (!Fnc.Empty(datas)) && datas.slice(0, listCount).map((data, index) => (
                <tr key={index}>
                  <td>{`${data.rank}위`}</td>
                  <td>{data.user_id}</td>
                  <td className="align_r font_style1"><span className="won"></span>{Math.abs(data.bet_money).toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{Math.abs(data.win_money).toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{data.prize_money.toLocaleString()}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
        { Fnc.Empty(datas) && <div className='table-no-data'>입상자 내역이 존재하지 않아요</div> }
        {
          !Fnc.Empty(datas) &&
          listCount < datas.length && (
            <div className="btns_wrap mt_30 mb_30">
              <Link className="btn_more" onClick={showMore}>더불러오기</Link>
            </div>
          )
        }
      </div>
    </>
  )
}